// import My from '@/view/my/Index.vue'
import { NativeTabNavigatoLayout } from '@/layout'
import News from '@/view/news/Index.vue'

const routes = [
  {
    path: '/nativeTab',
    component: NativeTabNavigatoLayout,
    children: [
      {
        path: 'news',
        name: 'news',
        // component: () => import('@/view/news/Index.vue')
        component: News,
      },
    ],
  },
  // {
  //   path: '/nativeTab/news',
  //   name: 'news',
  //   // component: () => import('@/view/news/Index.vue')
  //   component: News,
  // },
  // {
  //   path: '/news',
  //   name: 'news',
  //   component: () => import('@/view/news/Index.vue')
  // },
  {
    path: '/news/details',
    name: '/news/details',
    component: () => import('@/view/news/Details.vue')
  },
]

export default { routes }